import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Card,
  CardsCont,
  ContentCont,
  Description,
  Index,
  Title,
} from './ReflectionTaskSection.styles';
import PageSection from '../components/PageSection/PageSection';

const ReflectionTaskSection: FC = () => {
  const { t } = useTranslation();

  const tasks = useMemo(
    () => [
      {
        id: 1,
        title: t('results.report.reflectionTask.tasks.energyGain.title'),
        text: t('results.report.reflectionTask.tasks.energyGain.description'),
      },
      {
        id: 2,
        title: t('results.report.reflectionTask.tasks.energyDrain.title'),
        text: t('results.report.reflectionTask.tasks.energyDrain.description'),
      },
      {
        id: 3,
        title: t('results.report.reflectionTask.tasks.positiveAspects.title'),
        text: t('results.report.reflectionTask.tasks.positiveAspects.description'),
      },
    ],
    [t]
  );

  return (
    <PageSection ariaLabel="reflection-task">
      <PageSection.Header>
        <PageSection.Header.Title tag="h3" title={t('results.report.reflectionTask.title')} />
      </PageSection.Header>
      <PageSection.Content>
        <Description id="Description" as="p">
          {t('results.report.reflectionTask.description')}
        </Description>
        <CardsCont id="CardsCont">
          {tasks.map(({ id, title, text }) => (
            <Card id="Card" key={id}>
              <Index id="Index">{id}</Index>
              <ContentCont id="ContentCont">
                <Title id="Title" as="h5">
                  {title}
                </Title>
                <Description id="Description" as="p">
                  {text}
                </Description>
              </ContentCont>
            </Card>
          ))}
        </CardsCont>
      </PageSection.Content>
    </PageSection>
  );
};

export default ReflectionTaskSection;
